import { render, staticRenderFns } from "./NavTop.vue?vue&type=template&id=563fc301&scoped=true"
import script from "./NavTop.js?vue&type=script&lang=js&external"
export * from "./NavTop.js?vue&type=script&lang=js&external"
import style0 from "./NavTop.scss?vue&type=style&index=0&id=563fc301&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563fc301",
  null
  
)

export default component.exports